import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cscProductSpecifications = {
  imageGap: css`var(--csc-product-specifications-image-gap, ${csSpacing.spacing08})`,
  imageMaxHeight: css`var(--csc-product-specifications-image-max-height, var(--csc-product-specifications-image-size, 80px))`,
  imageMaxWidth: css`var(--csc-product-specifications-image-max-width, var(--csc-product-specifications-image-size, 80px))`,
}

export const style: CSSResult = css`
  .csc-product-specifications {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .specs-group {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .info-icon {
    color: ${csColorFunctional.info};
  }

  .info-icon.hidden-icon {
    opacity: 0;
  }

  .image-group {
    --cse-group-column-gap: ${cscProductSpecifications.imageGap};
    --cse-group-row-gap: ${cscProductSpecifications.imageGap};
  }

  .image-item {
    --cse-group-row-gap: ${csSpacing.spacing05};
  }

  cse-image {
    --cse-image-max-height: ${cscProductSpecifications.imageMaxHeight};
    --cse-image-max-width: ${cscProductSpecifications.imageMaxWidth};
  }
`
